let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4IojB")).then(() => parcelRequire('bz3yf'));